/*
 * @Author: xinxinfeng 2273234784@qq.com
 * @Date: 2024-07-01 14:11:23
 * @LastEditors: xinxinfeng 2273234784@qq.com
 * @LastEditTime: 2024-08-02 11:26:26
 * @FilePath: \crane-safety-manager\src\slices\auth\forgetpwd\thunk.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { userForgetPasswordSuccess, userForgetPasswordError } from './reducer';

import { APIClient } from '../../../helpers/api_helper';

export const userForgetPassword = (user, history) => async dispatch => {
    try {
        // 没有忘记密码的 API
        const response = await APIClient.post('/auth/signin', { user });
        if (response.data) {
            dispatch(userForgetPasswordSuccess('Reset link are sended to your mailbox, check there first'));
        }
    } catch (forgetError) {
        dispatch(userForgetPasswordError(forgetError));
    }
};
